import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";
import { formatViews, sortVideos } from "@/utils/video";

export default function HotRanking() {
  const hot = sortVideos(videos, "hot").slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-600">依据观看量排序，大家都在看这些</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
        {hot.map((v, i) => {
          const category = categories.find((c) => c.slug === v.category);
          return (
            <Link
              key={v.id}
              to={`/detail/${v.id}`}
              className="group flex items-center gap-3 md:gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <span
                className={`shrink-0 w-8 h-8 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                {i + 1}
              </span>
              <div className="relative w-28 md:w-36 shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
                <img
                  src={v.cover}
                  alt={`${v.title} 视频封面`}
                  title={`${v.title} - 免费视频`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {v.title}
                </h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  {category && (
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                      {category.name}
                    </span>
                  )}
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line" />
                    {formatViews(v.views)}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-timer-line" />
                    {v.duration}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}